import { render, staticRenderFns } from "./point-edit.vue?vue&type=template&id=3c7e2c0b&scoped=true&"
import script from "./point-edit.vue?vue&type=script&lang=ts&"
export * from "./point-edit.vue?vue&type=script&lang=ts&"
import style0 from "./point-edit.vue?vue&type=style&index=0&id=3c7e2c0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e2c0b",
  null
  
)

export default component.exports